import { message } from 'antd';
import { AxiosError } from 'axios';
import { errorMessageMap, ParsedApiError } from 'models/error';
import { errorParser } from 'services/error';
import { intl } from 'services/intl';
import { authService } from 'pages/auth/authService';

const showErrorMessages = (errors: ParsedApiError[]) => {
  errors.forEach((e) => {
    if (e.message) {
      message.error({
        key: e.error,
        content: errorMessageMap[e.error]
          ? intl.formatMessage({
              id: errorMessageMap[e.error],
            })
          : e.message,
      });
    }

    if (e.reasons && e.reasons.length > 0) {
      e.reasons.forEach((reason) => {
        reason &&
          message.error({
            key: reason,
            content: reason,
          });
      });
    }
  });
};

const hasUndefinedError = (errors: ParsedApiError[]) =>
  errors.find((x) => 'UNKNOWN' === x.error);

export const errorHandler = (axiosError: AxiosError) => {
  if (
    axiosError.response?.status === 403 &&
    axiosError.config?.data?.includes('refresh_token')
  ) {
    authService.logout();
    message.warning({
      content: intl.formatMessage({ id: 'auth.session.timeout' }),
      key: 'session-timeout',
    });
    return Promise.reject(axiosError);
  }

  const parsedErr = errorParser(axiosError.response?.data);
  if (parsedErr !== undefined && !hasUndefinedError(parsedErr)) {
    showErrorMessages(parsedErr);
  }

  return Promise.reject(axiosError);
};
